// extracted by mini-css-extract-plugin
export default {"supplierService":"SupplierService_supplierService__7K08E","form":"SupplierService_form__b+DAD","spinner":"SupplierService_spinner__gRIou","select":"SupplierService_select__u2Dgq"};